module.exports = __webpack_public_path__ + "media/stylesheets/images/lp/issue-01-d66e67a2d7d0c92174ade55cf0d3a302.png";